module.exports = __webpack_public_path__ + "img/av210.3d742971.png";